/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { ButtonProps } from '@coursera/cds-core';
import { Button } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';

import { TRACK_PROGRESS_BUTTON } from 'bundles/degree-home/components/v3-dpm/constants/trackingNameConstants';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/degree-home';

type Props = {
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  isIconButton?: boolean;
  degreeHomePagePath?: string;
  onClick?: () => void;
};

const TrackProgressButton = ({
  variant = 'primary',
  size = 'small',
  isIconButton,
  degreeHomePagePath,
  onClick,
}: Props) => {
  return (
    <Button
      component={TrackedLink2}
      withVisibilityTracking
      variant={variant}
      size={size}
      trackingName={TRACK_PROGRESS_BUTTON}
      icon={isIconButton ? <ArrowNextIcon size="small" /> : undefined}
      {...(degreeHomePagePath ? { href: degreeHomePagePath } : {})}
      onClick={onClick}
      edgeAlign="start"
    >
      {_t('Track progress')}
    </Button>
  );
};

export default TrackProgressButton;
